import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import {SelectComponent} from '../select/select.component';
import { PageResult } from '@core/model/pagination/page-result';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
  ],
  styleUrl: './pagination.component.css'
})
export class PaginationComponent {
  @Input() pageSize: number;
    @Input() pageSizeOptions: number[] = [];
    @Output() onPageSizeChanged: EventEmitter<number> = new EventEmitter<
      number
    >();
    @Input() pageIndex;
    @Input() pageResult: PageResult<any> = new PageResult<any>();
    @Input() title: string;
    @Input() activeIndex: number = 1;
    @Input() activeIndexReset: boolean = false;
    @Output() previousPageClicked = new EventEmitter<number>();
    @Output() nextPageClicked = new EventEmitter<number>();
    @Output() pageChanged = new EventEmitter<number>();
    startingPage:number=0;
    endingPage: number = 0;

  @Input() pageSizeShow: boolean = true;
  @Input() totalRecordsShow: boolean = true;
  @Input() totalPaginationCountShow: boolean = true;


    constructor() {}
    switchPage() {
      this.onPageSizeChanged.emit(this.pageSize);
    }

    pageLength(){
      var result = this.pageResult?.data?.length ? this.pageSize * this.pageIndex + 1 : 0;
      return Number.isNaN(result)? 1 : result;
    }

    /** End index for "Showing X to Y of Z" — use actual item count on current page so last page shows e.g. "1 to 13 of 13". */
    pageLengthTo(){
      const total = this.pageResult?.totalCount ?? 0;
      const onPage = this.pageResult?.data?.length ?? 0;
      const result = onPage > 0
        ? this.pageSize * this.pageIndex + onPage
        : total;
      return Number.isNaN(result) ? 1 : result === undefined ? 0 : result;
    }



  previousPage(): void {
    if (this.pageResult?.pageInfo?.hasPreviousPage && this.pageIndex > 0) {
      this.pageIndex--;
      this.activeIndex--;
      this.previousPageClicked.emit(this.pageIndex);
    }
  }

  nextPage(): void {
    const pages = Math.ceil((this.pageResult?.totalCount ?? 0) / this.pageSize);
    if (this.pageResult?.pageInfo?.hasNextPage && this.activeIndex < pages) {
      this.pageIndex++;
      this.activeIndex++;
      this.nextPageClicked.emit(this.pageIndex);
    }
  }

  getPages(): number[] {
    const pageArray: number[] = [];
    const totalCount = this.pageResult?.totalCount ?? 0;
    const pages = Math.ceil(totalCount / this.pageSize);

    if (pages < (this.activeIndex - 1)) {
      this.activeIndex = 1;
    }

    if (this.activeIndexReset) {
      this.activeIndex = 1;
    }

    for (let index = this.activeIndex - 1; index <= pages; index++) {
      if (index) pageArray.push(index);
    }
    this.startingPage = pageArray[0];
    this.endingPage = (this.startingPage + 2)> (pageArray[pageArray.length-1])? pageArray[pageArray.length-1] : this.startingPage + 2;
    return pageArray;
  }

  onPageClick(page: number): void {
    this.activeIndex = page;
    this.pageIndex = page - 1;
    this.pageChanged.emit(this.pageIndex);
  }

  getTotalPages(): number{
    const totalCount = this.pageResult?.totalCount ?? 0;
    return Math.ceil(totalCount / this.pageSize);
  }
}
